module.exports = ".alert {\n    color: #181515;\n    position: relative;\n    padding: .75rem 1.0rem;\n    margin-bottom: 1rem;\n    border-radius: 0;\n    margin-top: 1.0rem;\n}\n\n.alert img {\n    margin-right: 0.5rem;\n}\n\n.alert-danger {\n    background-color: #f8d7da;\n    border-bottom: 3px solid #b1b1b1;\n    border-top: none;\n    border-right: none;\n    border-left: none;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shared/mensaje-label-negocio/mensaje-label-negocio.component.css
// module id = ./src/app/components/shared/mensaje-label-negocio/mensaje-label-negocio.component.css
// module chunks = main